export default function ComingSoon() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[100vh] text-center space-y-4">
      <h1 className="text-5xl sm:text-8xl font-bold text-gray-500 dark:text-gray-400">
        BC PNP
      </h1>
      <h2 className="text-3xl sm:text-4xl font-bold text-gray-600 dark:text-gray-300">
        🚧 Coming Soon 🚧
      </h2>
    </div>
  );
}